// frontend/src/components/LandingPage/LandingPage.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import CategoryCard from "./CategoryCard";
import LoadingSpinner from "../common/LoadingSpinner";
import ErrorMessage from "../common/ErrorMessage";

import "./LandingPage.css";


const LandingPage = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        setLoading(true);
        const data = await api.getCategories();
        console.log('loaded categories', data);
        setCategories(data);
        setError(null);
      } catch (err) {
        setError("Failed to load categories. Please try again later.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadCategories();
  }, []);

  // const handleSelectCategory = (category) => {
  //   navigate(`/category/${category._id}`);
  // };

   const openCategoryTags = (category) => {
     navigate(`/category/${category._id}/tags`);
   };

  if (loading) {
    return <LoadingSpinner message="Loading gallery..." />;
  }

  if (error) {
    return (
      <ErrorMessage message={error} onRetry={() => window.location.reload()} />
    );
  }

  return (
    <div className="landing-main">
      <div className="landing-content">
        <h1 className="landing-title">Yuliart Gallery</h1>
        <p className="landing-subtitle">Explore my collections</p>

        <div className="categories-grid">
          {categories.map((category) => (
            <CategoryCard
              key={category._id}
              category={category}
              onClick={() => openCategoryTags(category)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
